import { RegistrationStep } from "../containers/RegistrationStep";
import { SummaryStep } from "../containers/SummaryStep";
import { SelectedPagesStep } from "../containers/SelectedPagesStep";

export const getStepsConfig = ({
  goNext,
  userData,
  setUserData,
  selectedType,
  setSelectedType,
}) => [
  {
    step: 1,
    title: "Select What You Would Like to Estimate",
    content: (
      <RegistrationStep
        nextStep={goNext}
        userData={userData}
        setUserData={setUserData}
        choseType={selectedType}
        handleTypeChange={setSelectedType}
      />
    ),
  },
  {
    step: 2,
    title: "Select Pages for Migration",
    skip: selectedType === "design",
    content: (
      <SelectedPagesStep
        nextStep={goNext}
        userData={userData}
        setUserData={setUserData}
      />
    ),
  },
  {
    step: 3,
    title: "Get Your Quote and Timeline",
    content: <SummaryStep userData={userData} setUserData={setUserData} />,
  },
];
